import { jsx as _jsx } from "react/jsx-runtime";
import { StyledCard } from './styles';
var Card = function (_a) {
    var children = _a.children, _b = _a.display, display = _b === void 0 ? 'block' : _b, bg = _a.bg, onClick = _a.onClick, maxWidth = _a.maxWidth;
    return (_jsx(StyledCard, { onClick: onClick, bg: bg, display: display, maxWidth: maxWidth, hasOnClick: !!onClick, children: children }));
};
export default Card;
